import React, {PureComponent} from "react"
import {Row} from "react-bootstrap"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import Select from "@irati/ui/src/FormItem/Select"
import {User, ProductSettingsRecognition} from "@irati/types"
import authentication from "@irati/auth"
import productSettingsService from "@irati/permissions/services/productSettings"
import SettingsLink from "./SettingsLink"
import {AreYouSurePopUp} from "../../AreYouSurePopUp"

interface Props extends InjectIntl {
  userTenant: User,
  title: string,
  description: string,
  action: keyof ProductSettingsRecognition,
  value: string
}

interface State {
  value: string,
  newValue: string | null
}

class PermissionOption extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      value: props.value,
      newValue: null
    }
  }

  handleChange = (newValue: string) => {
    this.setState({
      newValue
    })
    this.areYouSure.toggle()
  }

  updateRecognitionPermissions = () => {
    const {newValue} = this.state
    const {action} = this.props
    const business = authentication.business()

    this.setState({value: newValue!})

    return productSettingsService.updateRecognitionSettings(business.uuid, business.rootTeamId, {
      [action]: newValue
    })
  }

  render() {
    const {title, description, intl, options, ...props} = this.props
    const {value} = this.state
    return (
      <>
        <SettingsLink title={title} value={description}>
          <Row>
            <Select
              {...props}
              options={options.map((option) => ({
                ...option,
                label: intl.formatMessage({id: option.label})
              }))}
              hideLabel
              isClearable={false}
              isSearchable={false}
              onChange={(newValue: string) => this.handleChange(newValue)}
              value={value} />
          </Row>
        </SettingsLink>
        <AreYouSurePopUp
          ref={(c) => {
            this.areYouSure = c
          }}
          onSubmit={this.updateRecognitionPermissions}
          text={intl.formatMessage({id: "admin.components.areYouSurePopUp.text"})}
          cancelButtonText={intl.formatMessage({id: "admin.components.areYouSurePopUp.button.cancel"})}
          buttonText={intl.formatMessage({id: "admin.components.areYouSurePopUp.button.text"})} />
      </>
    )
  }
}

export default injectIntl(PermissionOption)
